import ImageLazyLoad from "../../../general/loading/ImageLazyLoad";
import React from "react";
import HeaderLink from "./HeaderLink";
import CompactOrder from "./CompactOrder";
import CompactInvoice from "./CompactInvoice";

const DetailItem = ({heading, headingStyle, body}) => {

    return (
        <>
            <p className="placed-order-detail-h" style={{...headingStyle}}>{heading}</p>
            <p className="placed-order-detail-b">{body}</p>
        </>
    )
}

const LineShipment = ({shipmentLine, order, invoices}) => {

    const product = shipmentLine["M_Product_ID"];
    const charge = shipmentLine["C_Charge_ID"];
    const uom = shipmentLine["C_UOM_ID"];

    const getHeader = () => {
        if(product) {
            return product.Value;
        } else if(charge) {
            return "Charge";
        } else {
            return "Other"
        }
    }

    const getDescription = () => {
        if(product) {
            return product.Name;
        } else if(charge) {
            return charge.Name;
        } else {
            return shipmentLine.Description;
        }
    }

    const getQuantity = () => {
        const entered = shipmentLine["QtyEntered"];
        if(uom && uom.Name) {
            return entered + " " + uom.Name;
        }
        return entered;
    }

    const header = getHeader();
    const description = getDescription();
    const imgUrl = product ? product.ImageURL : null;
    const quantity = getQuantity();

    return (
        <div className="tile">
            <div className="tile-header placed-order-line-header">
                <p style={{marginRight: "auto"}}>line: {shipmentLine.Line}</p>
                <HeaderLink txt={"Order"}>
                    {order ? <CompactOrder order={order}/>
                        : <p className={"account-link-empty"}>This line is not linked to an order</p> }
                </HeaderLink>
                <HeaderLink txt={"Invoice(s)"}>
                    {(invoices && invoices.length > 0) ?
                        invoices.map((e,i) => <CompactInvoice key={i} invoice={e}/>)
                        : <p className={"account-link-empty"}>This line is not linked to a shipment</p> }
                </HeaderLink>
            </div>
            <div className="tile-2-body placed-order-line-body">
                {imgUrl && <ImageLazyLoad
                    className={"placed-order-line-img"}
                    src={imgUrl}
                    alt="Product"
                />}
                <div className="placed-order-line-details">
                    <DetailItem heading={header}
                                headingStyle={{fontSize: "1em", fontWeight: "500", color:"var(--primary)"}}
                                body={description}/>
                    {(product || charge) &&
                        <DetailItem
                            heading="Quantity"
                            body={quantity}
                        />
                    }
                </div>
            </div>
        </div>
    )
}

export default LineShipment;
